export default __webpack_public_path__ + "static/media/PR.STREAK.FIVE_WEEKS.b2d4a1f0.jpg";